/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 25/5/2023
 */

import { createSlice } from "@reduxjs/toolkit";

export const authSlice = createSlice({
  name: "auth",
  initialState: {
    isSignedIn: 0,
    userStatus: null,
    isLoginDialogOpen: false,
    isRegisterDialogOpen: false,
  },

  reducers: {
    login: (state, action) => {
      const { access_token, details } = action.payload;
      sessionStorage.setItem("access_token", access_token);
      sessionStorage.setItem("isSignedIn", 1);
      sessionStorage.setItem("roles", details.roles);
      sessionStorage.setItem("userName", details.username);
      Object.assign(state, { isSignedIn: 1, details });
    },
    logout: (state) => {
      sessionStorage.removeItem("access_token");
      sessionStorage.removeItem("isSignedIn");
      sessionStorage.removeItem("roles");
      sessionStorage.removeItem("userName");
      state.isSignedIn = 0;
      delete state.details;
    },
    toggleLoginDialog: (state) => {
        state.isLoginDialogOpen = !state.isLoginDialogOpen;
      },
      toggleRegisterDialog: (state) => {
        state.isRegisterDialogOpen = !state.isRegisterDialogOpen;
      },
  },
});

export const { login, logout, toggleLoginDialog, toggleRegisterDialog } = authSlice.actions;
export const selectAuth = (state) => state.auth;

export default authSlice.reducer;
